import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`

export const ChipContainer = styled.div`
  min-height: 31px;
  flex-grow: 0;
  margin: 8px 8px 0px 0px;
  padding: 0px 9px 0px 12px;
  border-radius: 20px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202020;
`

export const RemoveIconContainer = styled.div`
  margin: 0px 0px 0px 5px;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  max-width: 20px;
  max-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #8a8a8a;
  cursor: pointer;
`